import { hy } from "../../../../date-fns/locale/hy.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    hy
  }
};